import React from 'react';
import Countdown from '@base/lib/Countdown';
import cn from 'classnames';
import { IListItem } from '@pro/activity/testerClub/interface';
import { useTrans } from 'base/utils/i18n'
import { removeLeadingZeros } from 'base/utils/numberHandle'

type IProps = {
    className?: string;
    product: IListItem
}
const TopInfo: React.FC<IProps> = (props) => {
    const { t } = useTrans();
    const { className, product } = props

    return(
        <div className={cn(className, 'flex')}>
            <div className={'g-item'}>
                <div className={'g-count'}>{product.points}</div>
                <span className={'g-text'}>{t('web_common_points')}</span>
            </div>

            <div className={cn('g-item')}>
                <Countdown
                    isShowDay={true}
                    endTime={+(product.endTime || '')}
                    render={(o) => {
                        if(+o.day > 0) {
                            return `
                                <div class="g-count">${removeLeadingZeros(o.day)}</div>
                                <span class="g-text">${t('web_shop_activity_days_left')}</span>
                            `
                        } else {
                            return `
                                <div class="g-count">${o.hour}:${o.minute}:${o.second}</div>
                                <span class="g-text">${t('web_shop_activity_remaining')}</span>
                            `
                        }
                    }}
                    endRender={()=> {
                        return `
                                <div class="g-count">0:00:00</div>
                                <span class="g-text">${t('web_shop_activity_remaining')}</span>
                            `
                    }}
                />
            </div>

            <div className={cn('g-item')}>
                <div className={'g-count'}>{product.num}</div>
                <span className={'g-text'}>{t('web_shop_activity_units_available')}</span>
            </div>
        </div>
    );
};

export default TopInfo